var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [{ icon: "user-tie", page: _vm.page_title.toUpperCase() }],
        },
      }),
      _c("v-container", { attrs: { fluid: "" } }, [
        _c("div", { staticClass: "lc-loose" }, [
          _c(
            "div",
            { staticClass: "lc-list" },
            [
              _c("div", { staticClass: "lc-item my-account-user" }, [
                _c("div", { staticClass: "lc-main" }, [
                  _c("div", { staticClass: "lc-icon-box lc-icon-box--round" }, [
                    _vm._v(_vm._s(_vm.initials)),
                  ]),
                  _c("div", { staticClass: "lc-info" }, [
                    _c("div", { staticClass: "lc-title" }, [
                      _vm._v(_vm._s(_vm.name)),
                    ]),
                    _c("div", { staticClass: "lc-sub" }, [
                      _vm._v(_vm._s(_vm.email)),
                    ]),
                  ]),
                ]),
              ]),
              _c(
                "v-card",
                {
                  staticClass: "my-account-options",
                  attrs: { flat: "", outlined: "" },
                },
                [
                  _c(
                    "v-list",
                    [
                      _c("PushNotificationsItem"),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/change-password")
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-3" },
                            [_c("v-icon", [_vm._v("mdi-lock-reset")])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("Cambiar contraseña"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-chevron-right"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialog_logout = true
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-3" },
                            [
                              _c("v-icon", { attrs: { color: "red" } }, [
                                _vm._v("mdi-export"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "red--text" },
                                [_vm._v("Cerrar sesión")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("DialogYesNo", {
        attrs: {
          open: _vm.dialog_logout,
          title: "Confirmar",
          message: "¿Estas seguro que quieres cerrar sesion?",
        },
        on: {
          cancel: function ($event) {
            _vm.dialog_logout = false
          },
          accept: _vm.logout,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }